import * as Yup from 'yup';
import { isYupNumberSchema, isYupStringSchema } from '../../../shared/utils/yup';
import { TemplateFormFieldValidation } from '../../interfaces/template-form';

export function MinValidation(
  validator: Yup.Schema<unknown>,
  validation: TemplateFormFieldValidation
) {
  const { value, errorMessage } = validation;

  if (typeof value === 'number' && (isYupNumberSchema(validator) || isYupStringSchema(validator))) {
    return (validator as Yup.StringSchema | Yup.NumberSchema).min(value, errorMessage);
  }

  return validator;
}
